import { useLanguage } from "@/context/LanguageContext";
import { scrollToId } from "@/components/atoms";

const LangToggle = () => {
  const { lang, setLang } = useLanguage();
  return (
    <div className="flex items-center font-mono text-[11px] tracking-[0.2em]" data-testid="lang-toggle">
      <button
        data-testid="lang-de-btn"
        onClick={() => setLang("de")}
        className={`px-2 py-1 transition-colors duration-300 ${lang === "de" ? "text-proof" : "text-smoke hover:text-ink"}`}
        aria-pressed={lang === "de"}
      >
        DE
      </button>
      <span className="text-ink/30">/</span>
      <button
        data-testid="lang-en-btn"
        onClick={() => setLang("en")}
        className={`px-2 py-1 transition-colors duration-300 ${lang === "en" ? "text-proof" : "text-smoke hover:text-ink"}`}
        aria-pressed={lang === "en"}
      >
        EN
      </button>
    </div>
  );
};

export const Header = () => {
  const { t } = useLanguage();
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-paper border-b border-hairline" data-testid="site-header">
      <div className="flex items-center justify-between px-5 md:px-10 h-16">
        <button
          data-testid="header-logo"
          onClick={() => scrollToId("#top")}
          className="flex items-baseline gap-3 group"
        >
          <span className="font-serif text-xl tracking-tight">Jo Lenz</span>
          <span className="hidden sm:inline font-mono text-[9px] uppercase tracking-[0.25em] text-smoke group-hover:text-proof transition-colors duration-300">
            {t.nav.tagline}
          </span>
        </button>
        <nav className="hidden md:flex items-center gap-8" data-testid="main-nav">
          {t.nav.items.map((item) => (
            <button
              key={item.href}
              data-testid={item.testid}
              onClick={() => scrollToId(item.href)}
              className="font-mono text-[11px] uppercase tracking-[0.2em] text-smoke hover:text-ink link-underline transition-colors duration-300"
            >
              {item.label}
            </button>
          ))}
        </nav>
        <LangToggle />
      </div>
    </header>
  );
};
